import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { CARBON_OFFSET_PROJECTS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchProjects = () => {
  return useQuery({
    queryKey: [CARBON_OFFSET_PROJECTS_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/projects",
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};
